// extracted by mini-css-extract-plugin
export default {"label":"styles_label__uE1Kn","input":"styles_input__5qnQj","sendMailBtn":"styles_sendMailBtn__McMJm"};